<svelte:options customElement={{
  tag: 'news-list',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' }
  }
}} />

<script>
  import SvgIcon from './SvgIcon.svelte';
  import Pager from './Pager.svelte';

  /**
   * ニュースリスト（ページネーション付き）
   * @prop {string} items - JSON配列 '[{"href":"...","type":"normal|tag|blank","date":"...","title":"...","category":"...","pdf":false,"pdfSize":"...","blank":false}]'
   */
  export let items = '[]';

  const ITEMS_PER_PAGE = 10;
  let currentPage = 1;

  let parsedItems = [];
  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('NewsList: Invalid items JSON', e);
      parsedItems = [];
    }
    currentPage = 1;
  }

  $: totalPages = Math.ceil(parsedItems.length / ITEMS_PER_PAGE);
  $: pagedItems = parsedItems.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
</script>

<div class="mod-newsList02 rt_bn_newsList">
  <ul class="mod-newsList02__list">
    {#each pagedItems as item}
    <li class="mod-newsList02__item rt_bn_newsList__item">
      <a
        href={item.href || '#'}
        class="mod-newsList02__link rt_bn_newsList__link"
        target={item.blank ? '_blank' : null}
        rel={item.blank ? 'noopener noreferrer' : null}
      >
        <time class="mod-newsList02__date">{item.date || ''}</time>
        {#if item.category}
          <span class="mod-newsList02__tag rt_bn_newsList__tag">{item.category}</span>
        {/if}
        <div class="mod-newsList02__content">
          <p class="mod-newsList02__title">
            <span class="mod-newsList02__title-in">{item.title || ''}</span>
            {#if item.pdf}
              <span class="mod-newsList02__pdf rt_bn_newsList__pdf">
                <SvgIcon name="pdf" size="lg" />
                {#if item.pdfSize}
                  <span class="__fileSize">({item.pdfSize})</span>
                {/if}
              </span>
            {/if}
            {#if item.blank}
              <span class="mod-newsList02__blank rt_bn_newsList__blank">
                <SvgIcon name="blank" size="lg" />
              </span>
            {/if}
          </p>
        </div>
      </a>
    </li>
    {/each}
  </ul>
</div>
